import { useState } from "react";
import "./login.scss";
import ForgetPassword from "./forgetpassword";
import Signup from "./signup";
import toast from "react-hot-toast";
import api from "../../../services/api";

const FieldError = ({ msg }: { msg?: string }) => {
    if (!msg) return null;
    return (
        <div style={{ color: '#E11D48', fontSize: '0.85rem', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
            {msg}
        </div>
    );
};

const Login = ({ onClose }: { onClose?: () => void }) => {
    const [showForgetPassword, setShowForgetPassword] = useState(false);
    const [showSignup, setShowSignup] = useState(false);

    const [emailOrMobile, setEmailOrMobile] = useState("");
    const [password, setPassword] = useState("");
    const [fieldErrors, setFieldErrors] = useState<any>({});

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setFieldErrors({});

        let errors: any = {};
        if (!emailOrMobile.trim()) {
            errors.emailOrMobile = "Please enter an email or mobile number.";
        }

        if (password.length < 6) {
            errors.password = "Password must be at least 6 characters.";
        }

        if (Object.keys(errors).length > 0) {
            setFieldErrors(errors);
            toast.error("Please fill in all required fields.");
            return;
        }

        try {
            const { response, data } = await api.post("/auth/login", { emailOrMobile, password });

            if (response.ok) {
                toast.success("Login Successful! You have been logged in successfully.");
                localStorage.setItem("user", JSON.stringify(data.user));
                setTimeout(() => { if (onClose) onClose(); }, 1500);
            } else {
                if (data.message && data.message.toLowerCase().includes("inactive")) {
                    toast.error("Your account is inactive. Please contact support for assistance.");
                } else {
                    toast.error("Invalid credentials. Please enter the correct email and password.");
                }
            }
        } catch (err) {
            toast.error("Error connecting to server.");
        }
    };

    if (showForgetPassword) {
        return <ForgetPassword onClose={onClose} />;
    }

    if (showSignup) {
        return <Signup onClose={onClose} onNavigateToLogin={() => setShowSignup(false)} />;
    }

    return (
        <div className="login-modal-backdrop" onClick={onClose}>
            <div className="login-popup-card" onClick={e => e.stopPropagation()}>
                <button className="close-button" onClick={onClose}>
                    <svg viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                    </svg>
                </button>
                <div className="popup-header">
                    <h3 className="text-center">Login</h3>
                </div>
                <div className="login-form-section">
                    <h4>Welcome Back</h4>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                            <label htmlFor="email"><span className="star">*</span>Email or Mobile Number</label>
                            <input
                                type="text"
                                id="email"
                                placeholder="Enter your email or mobile"
                                value={emailOrMobile}
                                onChange={e => { setEmailOrMobile(e.target.value); setFieldErrors({ ...fieldErrors, emailOrMobile: "" }); }}
                                style={{ borderColor: fieldErrors.emailOrMobile ? '#E11D48' : undefined }}
                                required
                            />
                            <FieldError msg={fieldErrors.emailOrMobile} />
                        </div>

                        <div className="form-group mb-3">
                            <label htmlFor="password"><span className="star">*</span>Password</label>
                            <input
                                type="password"
                                id="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={e => { setPassword(e.target.value); setFieldErrors({ ...fieldErrors, password: "" }); }}
                                style={{ borderColor: fieldErrors.password ? '#E11D48' : undefined }}
                                required
                            />
                            <FieldError msg={fieldErrors.password} />
                        </div>

                        <div className="form-actions">
                            <a href="#forgot" onClick={e => { e.preventDefault(); setShowForgetPassword(true); }}>Forgot password?</a>
                        </div>

                        <button type="submit" className="login-submit-btn">Login</button>
                    </form>

                    <div className="signup-link">
                        Don't have an account? <a href="#signup" onClick={(e) => { e.preventDefault(); setShowSignup(true); }}>Sign up here</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
